import { useState } from "react";
import { useSite } from "@/context/SiteContext";
import { FieldInput } from "@/components/admin/FieldInput";
import { SaveBar, useSectionSave } from "@/components/admin/ListEditor";

const FIELDS = [
  { name: "promo_enabled", label: "Show promo banner", type: "bool" },
  { name: "promo_text", label: "Promo banner text" },
  { name: "hero_badge", label: "Home hero badge" },
  { name: "pricing_footnote", label: "Pricing footnote" },
  { name: "peak_definition", label: "Peak definition", type: "textarea" },
  { name: "offpeak_definition", label: "Off-Peak definition", type: "textarea" },
  { name: "email", label: "Public email" },
  { name: "instagram", label: "Instagram handle (no @)" },
];

export function SettingsEditor() {
  const { content } = useSite();
  const [value, setValue] = useState(content.settings);
  const [dirty, setDirty] = useState(false);
  const { busy, save, reset } = useSectionSave("settings");
  return (
    <section className="rounded-md border border-white/10 bg-[#111] p-4 sm:p-6" data-testid="admin-settings-editor">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h2 className="h-display text-3xl text-white">Promos & settings</h2>
        <SaveBar dirty={dirty} busy={busy} testid="admin-settings"
          onSave={async () => { if (await save(value)) setDirty(false); }}
          onReset={async () => { const v = await reset(); if (v) { setValue(v); setDirty(false); } }} />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {FIELDS.map((f) => (
          <FieldInput key={f.name} field={f} value={value[f.name]} testid={`admin-settings-${f.name}`}
            onChange={(v) => { setValue({ ...value, [f.name]: v }); setDirty(true); }} />
        ))}
      </div>
    </section>
  );
}
